/* Mania de Mulher - carrinho lateral (drawer). API: window.MMCart */
(function () {
  if (window.MMCart) return;
  var root = document.getElementById('mm-drawer');
  if (!root) return;

  var URL_CART = root.getAttribute('data-url-cart') || '/cart';
  var URL_GET = URL_CART + '.js';
  var URL_ADD = (root.getAttribute('data-url-add') || '/cart/add') + '.js';
  var URL_CHANGE = (root.getAttribute('data-url-change') || '/cart/change') + '.js';

  var body = root.querySelector('[data-mm-body]');
  var foot = root.querySelector('[data-mm-foot]');
  var countEl = root.querySelector('[data-mm-count]');

  function money(cents) {
    var v = (Math.round(cents) / 100).toFixed(2).split('.');
    v[0] = v[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return 'R$ ' + v[0] + ',' + v[1];
  }

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function thumb(item) {
    if (!item.image) return '';
    var u = item.image.indexOf('?') > -1 ? item.image + '&width=200' : item.image + '?width=200';
    return '<img class="mm-dr-line__img" src="' + esc(u) + '" alt="' + esc(item.product_title) + '" loading="lazy">';
  }

  function syncCount(n) {
    if (countEl) countEl.textContent = n;
    document.querySelectorAll('.mm-cart-dot b, [data-mm-cart-count]').forEach(function (el) {
      el.textContent = n;
    });
  }

  function render(cart) {
    syncCount(cart.item_count);

    if (!cart.item_count) {
      body.innerHTML = '<div class="mm-dr-empty"><b>Seu carrinho esta vazio</b>Que tal escolher uma peca para chamar de sua?<br><a href="/collections/all">Ver produtos</a></div>';
      foot.hidden = true;
      return;
    }

    var html = '';
    cart.items.forEach(function (item, i) {
      var promos = (item.line_level_discount_allocations || []).map(function (d) {
        var t = d.discount_application && d.discount_application.title ? d.discount_application.title : 'Promocao';
        return '<span class="mm-dr-promo">' + esc(t) + ' -' + money(d.amount) + '</span>';
      }).join('');

      var price = item.original_line_price > item.final_line_price
        ? '<s>' + money(item.original_line_price) + '</s>' + money(item.final_line_price)
        : money(item.final_line_price);

      html += '<div class="mm-dr-line" data-line="' + (i + 1) + '">'
        + thumb(item)
        + '<div>'
        + '<a class="mm-dr-line__t" href="' + esc(item.url) + '">' + esc(item.product_title) + '</a>'
        + (item.variant_title && item.variant_title !== 'Default Title' ? '<div class="mm-dr-line__v">' + esc(item.variant_title) + '</div>' : '')
        + promos
        + '<div class="mm-dr-line__row">'
        + '<span class="mm-dr-qty"><button type="button" data-mm-step="-1" aria-label="Diminuir">-</button><span>' + item.quantity + '</span><button type="button" data-mm-step="1" aria-label="Aumentar">+</button></span>'
        + '<span class="mm-dr-line__price">' + price + '</span>'
        + '</div>'
        + '<button type="button" class="mm-dr-line__del" data-mm-remove>Remover</button>'
        + '</div></div>';
    });
    body.innerHTML = html;

    var saved = cart.original_total_price - cart.total_price;
    var cartPromos = (cart.cart_level_discount_applications || []).map(function (d) {
      return '<div class="mm-dr-tot"><span>' + esc(d.title || 'Desconto') + '</span><span class="mm-dr-save">-' + money(d.total_allocated_amount) + '</span></div>';
    }).join('');

    foot.hidden = false;
    foot.innerHTML = cartPromos
      + (saved > 0 ? '<div class="mm-dr-tot"><span>Voce economiza</span><span class="mm-dr-save">-' + money(saved) + '</span></div>' : '')
      + '<div class="mm-dr-tot mm-dr-tot--main"><span>Subtotal</span><b>' + money(cart.total_price) + '</b></div>'
      + '<a class="mm-dr-cta" href="/checkout">Finalizar compra</a>'
      + '<a class="mm-dr-cart-link" href="' + URL_CART + '">Ver carrinho completo</a>'
      + '<div class="mm-dr-note">Frete e cupons sao calculados na proxima etapa.</div>';
  }

  function refresh() {
    return fetch(URL_GET, { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { render(cart); return cart; })
      .catch(function () { });
  }

  function open() {
    root.classList.add('is-open');
    root.setAttribute('aria-hidden', 'false');
    document.body.classList.add('mm-drawer-open');
    refresh();
  }

  function close() {
    root.classList.remove('is-open');
    root.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('mm-drawer-open');
  }

  function add(items) {
    root.classList.add('is-busy');
    return fetch(URL_ADD, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
      .then(function (res) {
        root.classList.remove('is-busy');
        if (!res.ok) {
          alert(res.data && res.data.description ? res.data.description : 'Nao foi possivel adicionar ao carrinho.');
          return null;
        }
        open();
        return res.data;
      })
      .catch(function () {
        root.classList.remove('is-busy');
        alert('Nao foi possivel adicionar ao carrinho. Tente novamente.');
      });
  }

  function change(line, quantity) {
    root.classList.add('is-busy');
    return fetch(URL_CHANGE, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) { root.classList.remove('is-busy'); render(cart); })
      .catch(function () { root.classList.remove('is-busy'); });
  }

  root.addEventListener('click', function (e) {
    if (e.target.closest('[data-mm-close]')) { close(); return; }

    var step = e.target.closest('[data-mm-step]');
    if (step) {
      var el = step.closest('[data-line]');
      var cur = parseInt(el.querySelector('.mm-dr-qty span').textContent, 10) || 1;
      change(parseInt(el.getAttribute('data-line'), 10), Math.max(0, cur + parseInt(step.getAttribute('data-mm-step'), 10)));
      return;
    }

    var del = e.target.closest('[data-mm-remove]');
    if (del) {
      var l = del.closest('[data-line]');
      change(parseInt(l.getAttribute('data-line'), 10), 0);
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && root.classList.contains('is-open')) close();
  });

  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-mm-cart-open]');
    if (!trigger) return;
    e.preventDefault();
    open();
  });

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || form.tagName !== 'FORM') return;
    var action = form.getAttribute('action') || '';
    if (action.indexOf('/cart/add') === -1) return;

    e.preventDefault();
    var btn = form.querySelector('[type="submit"][name="add"], [data-mm-add]');
    /* usa o <span data-mm-label> quando existir, para nao apagar o icone do botao */
    var labelEl = btn ? (btn.querySelector('[data-mm-label]') || btn) : null;
    var label = labelEl ? labelEl.textContent : '';
    if (btn) { btn.disabled = true; labelEl.textContent = 'Adicionando...'; }

    var fd = new FormData(form);
    var props = {};
    fd.forEach(function (v, k) {
      var m = k.match(/^properties\[(.+)\]$/);
      if (m) props[m[1]] = v;
    });
    var item = { id: fd.get('id'), quantity: parseInt(fd.get('quantity') || '1', 10) || 1 };
    if (Object.keys(props).length) item.properties = props;

    add([item]).then(function () {
      if (btn) { btn.disabled = false; labelEl.textContent = label; }
    });
  });

  window.MMCart = { open: open, close: close, refresh: refresh, add: add, change: change };
  window.addEventListener('pageshow', function (e) { if (e.persisted) refresh(); });
})();
